export default {
  computed: {
    themeName() {
      return this.$vuetify.theme.dark ? 'dark' : 'light'
    },
  },
}
